import React, { useEffect } from "react";
import "../style/Service.css";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaCar,
  FaUsers,
  FaClock,
  FaLeaf,
  FaShieldAlt,
  FaMoneyBillWave,
} from "react-icons/fa";
import rideShareImage from "../assets/RIDESHARE.jpg"; // Add your ride share image path
import quickRideImage from "../assets/QUICK.jpg"; // Add your quick ride image path
import driverBenefitImage from "../assets/driver.jpg"; // Add your driver benefit image path
import customerBenefitImage from "../assets/customer.jpg"; // Add your customer benefit image path

const Service: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="service-page">
      <div className="service-hero" data-aos="fade-up">
        <h1>Our Services</h1>
        <p>Explore our range of services designed to meet your travel needs.</p>
      </div>

      <div className="service-section">
        <div className="container">
          <div className="service-card" data-aos="fade-right">
            <div className="service-content">
              <h2>
                <FaUsers className="service-icon" /> Ride Share
              </h2>
              <p>
                Our Ride Share service connects you with other passengers
                heading in the same direction, making your journey more
                affordable and eco-friendly.
              </p>
              <div className="service-features">
                <div
                  className="feature"
                  data-tooltip="Affordable and eco-friendly travel"
                >
                  <FaMoneyBillWave className="feature-icon" />
                  <span>Cost-Effective</span>
                </div>
                <div
                  className="feature"
                  data-tooltip="Reduce your carbon footprint"
                >
                  <FaLeaf className="feature-icon" />
                  <span>Eco-Friendly</span>
                </div>
                <div
                  className="feature"
                  data-tooltip="Meet new people while traveling"
                >
                  <FaUsers className="feature-icon" />
                  <span>Social Travel</span>
                </div>
              </div>
            </div>
            <img
              src={rideShareImage}
              alt="Ride Share"
              className="service-image"
            />
          </div>

          <div className="service-card" data-aos="fade-left">
            <div className="service-content">
              <h2>
                <FaCar className="service-icon" /> Quick Ride
              </h2>
              <p>
                Need to get somewhere fast? Our Quick Ride service offers
                immediate pickups and direct routes to your destination.
              </p>
              <div className="service-features">
                <div
                  className="feature"
                  data-tooltip="Get picked up in minutes"
                >
                  <FaClock className="feature-icon" />
                  <span>Fast Pickup</span>
                </div>
                <div
                  className="feature"
                  data-tooltip="Travel with peace of mind"
                >
                  <FaShieldAlt className="feature-icon" />
                  <span>Safe Travel</span>
                </div>
                <div
                  className="feature"
                  data-tooltip="Reach your destination directly"
                >
                  <FaCar className="feature-icon" />
                  <span>Direct Route</span>
                </div>
              </div>
            </div>
            <img
              src={quickRideImage}
              alt="Quick Ride"
              className="service-image"
            />
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section">
        <div className="benefit-category" data-aos="fade-up">
          <h2>Benefits for Drivers</h2>
          <div className="benefit-item">
            <img
              src={driverBenefitImage}
              alt="Driver Benefit"
              className="benefit-image"
            />
            <div className="benefit-text">
              <ul>
                <li
                  className="benefit-feature"
                  data-tooltip="Work on your own schedule"
                >
                  Flexible working hours to suit your schedule.
                </li>
                <li
                  className="benefit-feature"
                  data-tooltip="Earn more with transparency"
                >
                  Competitive earnings with a transparent commission structure.
                </li>
                <li
                  className="benefit-feature"
                  data-tooltip="More opportunities for rides"
                >
                  Access to a large customer base for more ride opportunities.
                </li>
                <li
                  className="benefit-feature"
                  data-tooltip="Navigate easily with our app"
                >
                  In-app navigation and support for a seamless experience.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="benefit-category" data-aos="fade-up">
          <h2>Benefits for Customers</h2>
          <div className="benefit-item">
            <img
              src={customerBenefitImage}
              alt="Customer Benefit"
              className="benefit-image"
            />
            <div className="benefit-text">
              <ul>
                <li
                  className="benefit-feature"
                  data-tooltip="Affordable options for everyone"
                >
                  Affordable rides with various options to choose from.
                </li>
                <li
                  className="benefit-feature"
                  data-tooltip="Travel safely with vetted drivers"
                >
                  Safe and reliable transportation with vetted drivers.
                </li>
                <li
                  className="benefit-feature"
                  data-tooltip="Easy booking through our app"
                >
                  Easy booking through our user-friendly app.
                </li>
                <li
                  className="benefit-feature"
                  data-tooltip="Support available anytime"
                >
                  24/7 customer support for any inquiries or issues.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
